module.exports = __webpack_public_path__ + "img/citi.049f5872.svg";